import { PopoverPlacement } from "@idui/react-popover";
import { TravelExplore } from "@mui/icons-material";
import type { FC } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "../../tooltips";
import { MapLibrePlaceInfoToggleStyled } from "./maplibre-place-info.styled";
import { useMapLibreControlContainer } from "./use-maplibre-control-container";

interface IMapLibrePlaceInfoToggleProps {
  isActive: boolean;
  onToggle: () => void;
}

/** The place-info switch, in MapLibre's control stack under the zoom buttons. */
export const MapLibrePlaceInfoToggle: FC<IMapLibrePlaceInfoToggleProps> = ({
  isActive,
  onToggle,
}) => {
  const { t } = useTranslation();
  const container = useMapLibreControlContainer("top-left");

  return createPortal(
    <FramerTooltip
      content={t("ui.PLACE_INFO_HINT")}
      placement={PopoverPlacement.right}
    >
      {/* a11y-exception: 29px like the zoom buttons it is stacked with; a 44px hit area would cover them */}
      <MapLibrePlaceInfoToggleStyled
        type="button"
        aria-label={t("ui.PLACE_INFO")}
        aria-pressed={isActive}
        $isActive={isActive}
        onClick={onToggle}
      >
        <TravelExplore aria-hidden />
      </MapLibrePlaceInfoToggleStyled>
    </FramerTooltip>,
    container,
  );
};
